
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useRef, useState } from 'react'
import { FilterMatchMode } from "primereact/api"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { get_emotions_from_sentiment, get_audio_history } from 'services/voiceInteractionService';
import { useDispatch, useSelector } from 'react-redux';
import { handleDuration, handleLoader, handleVoiceAudioTime, setFirstVoice, setRowsPerPageVoice } from 'redux/counterSlice';
import { toast } from 'react-toastify';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { formateDate } from "utils/formatDate";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { datatableView, datatableViewHover, expandNo, expandYes } from 'assets/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { handleVoiceIds } from 'redux/persistentSlice';
const moment = require('moment');

interface CommonType {
    name: string | null;
}

const VoiceHistory = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const firstVoice: number | null = searchParams.get('first') !== null ? Number(searchParams.get('first')) : 0;
    const rowsPerPageVoice: number | null = searchParams.get('rowsPerPage') !== null ? Number(searchParams.get('rowsPerPage')) : 5;
    const emotion: CommonType = searchParams.get('emotion') !== null ? { name: searchParams.get('emotion') } : { name: "All" };
    const blackListedWords: CommonType = searchParams.get('blackListedWords') !== null ? { name: searchParams.get('blackListedWords') } : { name: "All" };
    const selling: CommonType = searchParams.get('selling') !== null ? { name: searchParams.get('selling') } : { name: "All" };
    const dropdownRef: any = useRef(null);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const [selectedProducts, setSelectedProducts] =
        useState<Record<string, any>>()
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [audioFiles, setAudioFiles] = useState([]);
    const [is_collapse, setIs_collapse] = useState("");
    const [selectedEmotion, setSelectedEmotion] = useState<CommonType | null>(emotion);
    const [selectedCSellUsell, setSelectedCSellUsell] = useState<CommonType | null>(selling);
    const [selectedBlackListed, setSelectedBlackListed] = useState<CommonType | null>(blackListedWords);
    const [emotions, setEmotions] = useState<string[]>([]);
    const [first, setFirst] = useState(firstVoice); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageVoice); // State to control the rows per page
    const [dates, setDates] = useState<Date[]>([new Date(new Date().getFullYear(), new Date().getMonth(), 1), new Date()]);
    const [isDropdownOpenEmotion, setDropdownOpenEmotion] = useState(false);
    const [isDropdownOpenblackListed, setDropdownOpenBlackListed] = useState(false);
    const [isDropdownOpenSell, setDropdownOpenSell] = useState(false);
    const optionsWords = [{ name: "All" }, { name: "Yes" }, { name: "No" }]
    const customDropdownIcon = (dropdown: boolean) => {
        return (
            <span className={`pi ${dropdown ? 'pi-chevron-up' : 'pi-chevron-down'}`} />
        );
    };



    useEffect(() => {
        const sidebar = document.getElementById('wrapper');

        const handleSidebarHover = () => {
            if (sidebar && sidebar.classList.contains('sidebar--open')) {
                // Close the dropdown
                dropdownRef.current?.hide();
            }
        };

        sidebar && sidebar.addEventListener('mouseover', handleSidebarHover);

        return () => {
            sidebar && sidebar.removeEventListener('mouseover', handleSidebarHover);
        };
    }, []);



    const getEmotions = async () => {
        try {
            const { result, error } = await get_emotions_from_sentiment();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            const temp = result.map((i: string) => { return { name: i.charAt(0).toUpperCase() + i?.slice(1) } });
            temp.unshift({ name: "All" })
            setEmotions(temp);
        } catch (error: any) {
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const getHistory = async (data: string) => {
        dispatch(handleLoader(true));
        const from_date = formateDate(dates[0])
        const to_date = formateDate(dates[1])
        const tempEmo = selectedEmotion?.name === "All" ? "" : selectedEmotion?.name?.toLowerCase()
        const tempBlak = selectedBlackListed?.name === "All" ? "" : selectedBlackListed?.name?.toLowerCase();
        const tempSell = selectedCSellUsell?.name === "All" ? "" : selectedCSellUsell?.name?.toLowerCase();
        try {

            const { result, error } = await get_audio_history(from_date, to_date, tempEmo, tempBlak, tempSell);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            dispatch(handleLoader(false));
            setAudioFiles(result.sorted_data);
            dispatch(handleVoiceIds(result.audio_ids));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Reset the first page to 0 when filter is applied
        setFirst(0);
        navigate(`/voice?first=${first}`)
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        })
        setGlobalFilterValue("")
    }

    useEffect(() => {
        getEmotions();
        initFilters();
        // CustomerService.getCustomersMedium().then((data) => setNotifications(data));
    }, []);
    useEffect(() => {
        if (dates[1] !== null) {
            getHistory("get");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dates, selectedEmotion, selectedBlackListed, selectedCSellUsell]);

    const capitalizeFirstLetter = (word: string) => {
        if (word === "joy") {
            return (<span className="emotion-tags joy">
                Joy
            </span>)

        } else if (word === "sadness") {
            return <span className="emotion-tags sad">
                Sadness
            </span>

        } else if (word === "anger") {
            return <span className="emotion-tags anger">
                Anger
            </span>

        } else if (word === "fear") {
            return <span className="emotion-tags fear">
                Fear
            </span>

        } else if (word === "love") {
            return <span className="emotion-tags love">
                Love
            </span>

        } else if (word === "neutral") {
            return <span className="emotion-tags surprise">
                Neutral
            </span>

        }
    };

    const handleDateSelection = (e: any) => {
        const selectedDatesArray = e.value;
        if (selectedDatesArray?.length === 2) {
            // Update the selected dates when a valid range is selected
            setDates(selectedDatesArray);
            if (selectedDatesArray[1] !== null) {
                setFirst(0);
            }
        } else {
            // Clear the selection when less than two dates are selected
            setDates([]);
        }
    };

    const handleDescription = (rowData: any) => {
        if (rowData.Description_result?.length > 0) {
            return is_collapse === rowData.audio_id ?
                <span className='icon-expand' onClick={() => setIs_collapse("")}><i> <img
                    src={expandYes}
                    alt='expand-yes' />
                </i>{rowData.Description_result}{" "}</span> : <span className='icon-expand' onClick={() => setIs_collapse(rowData.audio_id)}> <i><img
                    src={expandNo}
                    alt='expand-no' /></i>{rowData?.Description_result?.slice(0, 70).trim()}{rowData?.Description_result?.length > 70 ? "..." : " "}</span>
        }
    }

    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        navigate(`/voice?first=${first}`)
    };

    useEffect(() => {
        dispatch(handleDuration(0))
        dispatch(handleVoiceAudioTime("00:00.00"))
    }, [])

    const [is_hover_eye, setIs_hover_eye] = useState<string>("");

    const rowClassName = (rowData: any) => {
        return {
            'expanded-row': rowData.audio_id === is_collapse
        };
    };

    useEffect(() => {
        navigate(`/voice?first=${first}&rowsPerPage=${rowsPerPage}&blackListedWords=${selectedBlackListed?.name}&selling=${selectedCSellUsell?.name}&emotion=${selectedEmotion?.name}`)
    }, [first, rowsPerPage, selectedBlackListed, selectedCSellUsell, selectedEmotion])

    return (
        <div className='p-4 content-wrapper w-100 ' id='voice'>
            <section className="switch-section user-management-section">
                <div className="datatable-wrapper">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                        <h4 className="mb-0">My Calls</h4>
                        <div className='ali mycalls-head'>
                            <div className="mycalls-head-right">
                                <div className='voice-filter-col mt-1 mb-1'>
                                    <span className='text-sm' >Black Listed Word: </span>
                                    <Dropdown ref={dropdownRef} value={selectedBlackListed} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => { setSelectedBlackListed(e.value); setFirst(0) }} options={optionsWords}
                                        placeholder="Select a BlackListed" optionLabel="name" className="ms-3 fw-bold text-sm"
                                        // onShow={() => setDropdownOpenBlackListed(true)}
                                        // onHide={() => setDropdownOpenBlackListed(false)}
                                        dropdownIcon={customDropdownIcon(isDropdownOpenblackListed)}
                                    />
                                </div>
                                <div className='voice-filter-col mt-1 mb-1'>
                                    <span className='text-sm'>Crosssell/Upsell: </span>
                                    <Dropdown ref={dropdownRef} value={selectedCSellUsell} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => { setSelectedCSellUsell(e.value); setFirst(0) }} options={optionsWords}
                                        placeholder="Select an Emotion" optionLabel="name" className="ms-3 fw-bold text-sm"
                                        // onShow={() => setDropdownOpenSell(true)}
                                        // onHide={() => setDropdownOpenSell(false)}
                                        dropdownIcon={customDropdownIcon(isDropdownOpenSell)}
                                    />
                                </div>
                                <div className='voice-filter-col mt-1 mb-1'>
                                    <span className='text-sm'>Emotion: </span>
                                    <Dropdown ref={dropdownRef} value={selectedEmotion} style={{ background: "rgba(1, 61, 185, 0.009)", boxShadow: "none" }} onChange={(e) => { setSelectedEmotion(e.value); setFirst(0); }
                                    } options={emotions}
                                        placeholder="Select an Emotion" optionLabel="name" className="ms-3 fw-bold text-sm"
                                        // onShow={() => setDropdownOpenEmotion(true)}
                                        // onHide={() => setDropdownOpenEmotion(false)}
                                        dropdownIcon={customDropdownIcon(isDropdownOpenEmotion)}
                                    />
                                </div>
                                <div className='voice-filter-col mt-1 mb-1 filter-calendar'>
                                    <Calendar
                                        maxDate={new Date()}
                                        value={dates}
                                        onChange={handleDateSelection}
                                        selectionMode="range"
                                        showIcon
                                        readOnlyInput
                                        hideOnRangeSelection
                                    // className="custom-calendar-icon ps-2 text-sm"
                                    />
                                </div>
                                <div className='d-flex- align-items-center mt-1 mb-1'>
                                    <IconField iconPosition="right" className='user-input'>
                                        <InputIcon className="pi pi-search"></InputIcon>
                                        <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
                                    </IconField>
                                </div>
                            </div>
                        </div>
                    </div>
                    <DataTable
                        selection={selectedProducts}
                        onSelectionChange={(e) => setSelectedProducts(e.value)}
                        paginator
                        first={first}
                        onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                        filters={filters}
                        globalFilterFields={["audio_filename", "Title_result", "is_black_list_word", "is_selling", "emotion", "Description_result"]}
                        rows={rowsPerPage}
                        scrollable={true}
                        rowsPerPageOptions={[5, 10, 25]}
                        sortField={sortField}
                        sortOrder={sortOrder}
                        sortMode="single"
                        onSort={handleSort}
                        value={audioFiles}
                        tableStyle={{}}
                        emptyMessage="No voice records found"
                        rowClassName={rowClassName}
                    ><Column style={{ width: '10%' }} field="audio_filename" header="Name" sortable={true} />
                        <Column style={{ width: '10%' }} field="Title_result" header="Title" sortable={true} />
                        <Column style={{ width: '20%' }} field="Description_result" header="Description" body={(rowData: any) => handleDescription(rowData)} sortable={true} />
                        <Column field="is_black_list_word" header="Black Listed Words Exist?" body={(rowData: any) => (rowData.is_black_list_word.charAt(0).toUpperCase() + rowData?.is_black_list_word?.slice(1))} sortable={true}></Column>
                        <Column field="is_selling" header="Crosssell/ Upsell Opportunities?" body={(rowData: any) => (rowData.is_selling.charAt(0).toUpperCase() + rowData?.is_selling?.slice(1))} sortable={true}></Column>
                        <Column field="emotion" header="Emotion" body={(rowData: any) => capitalizeFirstLetter(rowData?.emotion)} sortable={true} />
                        <Column field="created_at" header="Date & Time" body={(rowData: any) => (moment(rowData.created_at).format('MMM DD, YYYY HH:mm:ss'))} sortable={true}></Column>
                        <Column header="Action" body={(rowData) => (
                            <span style={{ cursor: "pointer" }} onMouseEnter={() => setIs_hover_eye(rowData.audio_id)} onMouseLeave={() => setIs_hover_eye("")} onClick={() => navigate(`/voice/${rowData?.audio_id}`)}>
                                <img src={is_hover_eye === rowData.audio_id ? datatableViewHover : datatableView} alt='view-icon' />
                            </span>
                        )}
                        ></Column>
                    </DataTable>
                </div>
            </section>
        </div>
    )
}

export default VoiceHistory